module.exports = __webpack_public_path__ + "static/media/cnh-front.092a4039.jpg";